/**
 * @Author: v_jppjpeng
 * @Date: 2024-09-10 20:26:52
 * @Explain: 设置管理 - 埋点
 */

export default {
  /** 点击切换体验项目 */
  401: 'clickDemoProjectError',
  /** 创建项目 */
  402: 'createProjectError',
  /** 通过pnt已有的项目，进行创建 */
  403: 'createProjectPntIdError',
  /** 点击操作-进入-切换项目 */
  404: 'switchProjectError',

  /** 点击提交域名认证 */
  405: 'clickSubmitDomainError',

  /** 点击新增发件地址 */
  406: 'clickAddSenderAddressError',
  /** 点击编辑发件地址 */
  407: 'clickEditSenderAddressError',

  /** 点击新增发件人名称 */
  408: 'clickAddSenderNameError',
  /** 点击编辑发件人名称 */
  409: 'clickEditSenderNameError',

  /** 新增拒绝名单-手动上传 */
  410: 'clickManualAddBlockError',
  /** 新增拒绝名单-导入csv */
  411: 'clickImportAddBlockError',
};
